/* GeneratedContentHash: 609414cd2507336fc18c9554eb529d8c17998b08364647bdfa1d2362e3cd9070 */
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/

export const PLACEMENT_ID = 'home-recommended-action';
